import demo from './demo';
import diagram from './diagram';
import diagramEditingController from './diagramEditingController';
import index from './index';
import login from './login';
import main from './main';
import options from './options';
import otherStudyDetails from './otherStudyDetails';
import patient from './patient';
import patientDetails from './patientDetails';
import patientsList from './patientsList';
import scheduled from './scheduled';
import studyDetails from './studyDetails';
import worklist from './worklist';
import speedTest from './speedTest';
import chatConversationCtrl from './chatConversationController';



// WEBPACK FOOTER //
// ./src/scripts/controllers/index.js